import React from 'react'
import { FormattedMessage } from 'react-intl'

import { NonCompliantRulesFragment } from '../../../lib/graphql'

export const NonCompliantLabel = ({
  clientProposal,
}: {
  clientProposal: NonCompliantRulesFragment
}) => {
  if (
    clientProposal.isNonCompliantBudget &&
    clientProposal.isNonCompliantHouse
  ) {
    return (
      <FormattedMessage
        id='ui.NonCompliantLabel.both'
        defaultMessage='Budget et lieu non conformes aux politiques de voyage de votre entreprise.'
      />
    )
  }
  if (clientProposal.isNonCompliantBudget) {
    return (
      <FormattedMessage
        id='ui.NonCompliantLabel.budget'
        defaultMessage='Budget non conforme aux politiques de voyage de votre entreprise.'
      />
    )
  }
  if (clientProposal.isNonCompliantHouse) {
    return (
      <FormattedMessage
        id='ui.NonCompliantLabel.house'
        defaultMessage='Lieu non conforme aux politiques de voyage de votre entreprise.'
      />
    )
  }

  return null
}
